import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@packages/shared';

const OocvTableFragment = graphql(/* GraphQL */ `
  fragment OocvTableFragment on OocvTable {
    headline
    rows {
      key
      value
    }
  }
`);

/**
 * `OocvTable` is a predefined custom table with one table head and n table rows.
 * It is built using the mui table components.
 * */
export const OocvTable = ({
  oocvTableData,
}: {
  oocvTableData: FragmentType<typeof OocvTableFragment>;
}) => {
  const { headline, rows } = getFragmentData(OocvTableFragment, oocvTableData);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2} variant="head">
            {headline}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={idx}>
            <TableCell>{row.key}</TableCell>
            <TableCell>
              <Box
                sx={{ whiteSpace: 'pre-line' }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: row.value,
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
